import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, withKeys as _withKeys, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { GlobalEvents } from 'vue-global-events'
import { eventBus } from '@/utils'
import { playbackService, socketService } from '@/services'
import { favoriteStore, queueStore } from '@/stores'


export default /*#__PURE__*/_defineComponent({
  __name: 'HotkeyListener',
  setup(__props) {

const togglePlayback = (e: KeyboardEvent) => {
  if (
    !(e.target instanceof Document) &&
    (e.target as Element).matches('input, textarea, button, select') &&
    !(e.target as Element).matches('input[type=range]')
  ) {
    return true
  }

  e.preventDefault()
  playbackService.toggle()

  return false
}

/**
 * Play the previous song when user presses K.
 */
const playPrev = (e: KeyboardEvent) => {
  if (!(e.target instanceof Document) && (e.target as Element).matches('input, select, textarea')) {
    return true
  }

  e.preventDefault()
  playbackService.playPrev()

  return false
}

/**
 * Play the next song when user presses J.
 */
const playNext = (e: KeyboardEvent) => {
  if (!(e.target instanceof Document) && (e.target as Element).matches('input, select, textarea')) {
    return true
  }

  e.preventDefault()
  playbackService.playNext()

  return false
}

/**
 * Put focus into the search field when user presses F.
 */
const search = (e: KeyboardEvent) => {
  if (
    !(e.target instanceof Document) &&
    (e.target as Element).matches('input, select, textarea') && !(e.target as Element).matches('input[type=range]')
  ) {
    return true
  }

  if (e.metaKey || e.ctrlKey) {
    return true
  }

  e.preventDefault()
  eventBus.emit('FOCUS_SEARCH_FIELD')

  return false
}

/**
 * Like/unlike the current song when use presses L.
 */
const toggleLike = (e: KeyboardEvent) => {
  if (!(e.target instanceof Document) && (e.target as Element).matches('input, select, textarea')) {
    return true
  }

  if (!queueStore.current) {
    return false
  }

  favoriteStore.toggleOne(queueStore.current)
  socketService.broadcast('SOCKET_SONG', queueStore.current)

  return false
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(GlobalEvents), {
    onKeydown: [
      _withKeys(togglePlayback, ["space"]),
      _withKeys(playNext, ["j"]),
      _withKeys(playPrev, ["k"]),
      _withKeys(search, ["f"]),
      _withKeys(toggleLike, ["l"])
    ]
  }, null, 8, ["onKeydown"]))
}
}

})